$(document).on("turbolinks:load", function () {
  // $('[data-toggle="tooltip"]').tooltip({ placement: "left" });

  var $recEstimate = $("#rec-estimate");

  var createRecEstimate = function () {
    var orderId = $recEstimate.data("order_id");
    var url = "/cart/orders/" + orderId + "/rec_estimate";

    $.ajax({
      type: "POST",
      dataType: "json",
      url: url,
      success: function (data) {
        var subtotal = parseFloat($recEstimate.data("cart_total"));
        var rec_cost = parseFloat(data.cost);
        var grand_total = subtotal + rec_cost;

        $(".green-grand-total").html("$" + grand_total.toFixed(2));
        $(".rec-cost").html("$" + parseFloat(data.cost).toFixed(2));
        $("input#purchase_rec").removeAttr("disabled");
        $(".rec").show();
        $(".no-rec").hide();
      },
    });
  };

  if (!$recEstimate.data("rec_estimate")) {
    if ($recEstimate.length > 0) {
      createRecEstimate();
    }
  }

  $(document).on("change", ".toggle-rec", function () {
    if ($(this).is(":checked")) {
      $(".green-order").show();
      $("table.cart-items tr.cart-item td").css("background-color", "#CAF6C8");
      $(".non-green-order").hide();
    } else {
      $(".green-order").hide();
      $(".non-green-order").show();
      $("table.cart-items tr.cart-item td").css("background-color", "");
    }
  });

  $(document).on("touchstart", ".cloverly-tooltip", function () {
    $('[data-toggle="tooltip"]').tooltip("toggle");
  });
});
